import React, { useState, useEffect, useCallback } from "react";
import { Spin, Tag, Tooltip } from "antd";
import moment from "moment/moment";
import Bridge from "../../../constants/Bridge";
import UserListModal from "./UserListModal";

const InProgress = ({ list, refresh }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRecords = useCallback(() => {
    let arr = [];
    setLoading(true);
    if (list.length > 0) {
      for (let item of list) {
        if (item.status == "In-Progress") {
          arr.push(item);
        }
      }
    }
    setRecords(arr);
    setLoading(false);
  }, [list]);

  useEffect(() => {
    fetchRecords();
  }, [list, fetchRecords]);

  const voteForThisFeature = (item, vote_type, is_voted_already) => {
    if (is_voted_already == "yes") {
      vote_type = "";
    }
    let params = {
      fr_id: item.fr_id,
      user_id: localStorage.getItem("consortia_user_id"),
      vote_id: item.vote_id,
      vote_type,
    };
    Bridge.feature_roadmap
      .vote(params)
      .then((result) => {
        if (result.status == "1") {
          refresh();
        }
      })
      .catch((error) => {});
  };

  return (
    <div>
      <Spin spinning={loading}>
        <div className="container px-0">
          <div className="row px-0">
            {records.length > 0 &&
              records.map((item, index) => {
                let date_created = moment(
                  item.date_created.split(" ")[0]
                ).format("DD MMM, YYYY");
                let release_date = item.released_date
                  ? moment(item.released_date).format("MM/DD/YYYY")
                  : "";
                return (
                  <div className="col-lg-12 px-0" key={index}>
                    <div className="feature-card">
                      <div className="vote-section">
                        <div>
                          {item.vote_type == "upvote" ? (
                            <Tooltip title="I want it">
                              <i
                                className="far fa-thumbs-up"
                                style={{
                                  color: "#1cc31d",
                                }}
                              ></i>
                            </Tooltip>
                          ) : (
                            <Tooltip title="I want it">
                              <i
                                className="far fa-thumbs-up"
                                style={{
                                  cursor: "pointer",
                                  color: "#c9c8ca",
                                }}
                                onClick={() =>
                                  voteForThisFeature(item, "upvote")
                                }
                              ></i>
                            </Tooltip>
                          )}
                        </div>
                        <br />
                        <div>
                          {item.vote_type == "downvote" ? (
                            <Tooltip title="Not interested">
                              <i
                                className="far fa-thumbs-down"
                                style={{
                                  color: "#fc0042",
                                }}
                              ></i>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Not interested">
                              <i
                                className="far fa-thumbs-down"
                                style={{
                                  cursor: "pointer",
                                  color: "#c9c8ca",
                                }}
                                onClick={() =>
                                  voteForThisFeature(item, "downvote", "no")
                                }
                              ></i>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                      <div className="content">
                        <div className="row">
                          <div className="col-lg-8">
                            <h4  style={{
                      marginTop: window.innerWidth > 400 ? 0 : 20,
                        }}>{item.title}</h4>
                          </div>
                          <div className="col-lg-3">
                            {item.released_date && (
                              <Tag
                                color="blue"
                                style={{ fontSize: 18, float: "right" , marginBottom: window.innerWidth > 400 ? 0 : 3}}
                                                           >
                                <span>
                                  <span style={{ fontWeight: "600", }}>
                                    Release Date:
                                  </span>{" "}
                                  {release_date}
                                </span>
                              </Tag>
                            )}
                          </div>
                        </div>
                        <div>
                          <p>{item.description}</p>
                          {item.feature_type == "Feature" && (
                            <div className="feature-type-sec">
                              <Tag
                                color="green"
                                style={{
                                  marginLeft: 10,
                                  height: "fit-content",
                                  fontSize: window.innerWidth < 400 ? 13 : 18,
                                }}
                              >
                                Feature
                              </Tag>
                            </div>
                          )}
                          {item.feature_type == "Bug" && (
                            <div className="feature-type-sec">
                              <Tag
                                color="red"
                                style={{
                                  marginLeft: 10,
                                  height: "fit-content",
                                  fontSize: 18,
                                }}
                              >
                                Bug
                              </Tag>
                            </div>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-lg-9"></div>
                          <div className="col-lg-3">
                            <div
                              className="d-flex justify-content-end"
                              style={{ position: "relative" }}
                            >
                              <div className="created-by-user-name">
                                <span>{date_created}</span>
                                <div className="inner-details">
                                  <div>
                                    <span>
                                      Request created by{" "}
                                      <strong>{item.name}</strong>
                                    </span>
                                  </div>
                                </div>
                                <div className="inner-details">
                                  <div>
                                    <span className="d-flex">
                                      Interested &nbsp;
                                      <UserListModal data={item} />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="row" style={{ backgroundColor: "#fff" }}>
            {records.length == 0 && (
              <div className="col-lg-12 px-0">
                <div className="not-available-section">
                  <img
                    style={{ maxWidth: 300 }}
                    src={require("../../../../assets/img/featureRoadmap/not-available2.jpg")}
                  />
                  <h4 className="text-center">No in progress requests.</h4>
                </div>
              </div>
            )}
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default InProgress;
